import { IRouteData } from './types'

import routesEnum from './enum'

// Screens
import { HomeContainer } from '../Home'
import { EndContainer } from '../End'

export const routesData: IRouteData[] = [
	{
		component: HomeContainer,
		key: routesEnum.HOME,
		name: 'Home',
		path: routesEnum.HOME
	},
	{
		component: HomeContainer,
		key: routesEnum.HOME,
		name: 'Home',
		path: routesEnum.HOME,
		params: 'cupom'
	},
	{
		component: EndContainer,
		key: routesEnum.PAYMENT_PIX,
		name: 'Pagamento',
		path: routesEnum.PAYMENT_PIX,
		params: 'subscription_id'
	},
	{
		component: EndContainer,
		key: routesEnum.PAYMENT_PIX,
		name: 'Pagamento',
		path: routesEnum.PAYMENT_PIX
	},
	{
		component: EndContainer,
		key: routesEnum.PAYMENT_CREDIT,
		name: 'Pagamento',
		path: routesEnum.PAYMENT_CREDIT
	}
]
